export default {
	stringListFormat,
	getColumnData,
	formatCurrency,
	getName,
	formatCNJ,
}

function getColumnData(
	trial: object,
	column: string,
	format?: Function,
): string {
	const propVal = trial[column]

	if (format) {
		return format(propVal)
	}

	if (propVal) {
		return propVal.toString()
	}

	return ''
}

function stringListFormat(list: string[]) {
	return list.join(', ')
}

function getName(item) {
	return item && item.name
}

function numberToString(n: number): string {
	let result: string = n.toString().replace(/\./, ',')
	result = result.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
	return result
}

function formatCurrency(n: number): string {
	return 'R$ ' + numberToString(n)
}

function formatCNJ(cnj: string): string {
	if (!cnj) return ''

	const formattedCnj: string[] = []
	formattedCnj.push(cnj.substr(0, 7))
	formattedCnj.push('-')
	formattedCnj.push(cnj.substr(7, 2))
	formattedCnj.push('.')
	formattedCnj.push(cnj.substr(9, 4))
	formattedCnj.push('.')
	formattedCnj.push(cnj.substr(13, 1))
	formattedCnj.push('.')
	formattedCnj.push(cnj.substr(14, 2))
	formattedCnj.push('.')
	formattedCnj.push(cnj.substr(16, 4))

	return formattedCnj.join('')
}
